export const GET_CONTROLLER_LIST = 'GET_CONTROLLER_LIST';
export const ADD_CONTROLLER = 'ADD_CONTROLLER';
